<template>
  <div class="app-shell" style="width: 100%; height: 100%;">
    <el-container class="app-container">
      <el-aside width="353px" class="sidebar-container">
        <Sidebar ref="sidebar" :curId="curId" :isLoading="$refs.banner?.loading" @changeCurId="changeCurId" @delCurId="delCurId"/>
      </el-aside>

      <el-main class="main-content">
        <keep-alive include="BannerComponent">
          <Banner
              ref="banner"
              :curId.sync="curId"
              @openLogin="openLogin"
              @openResetPass="openResetPass"
              @openMobileSidebar="openMobileSidebar"
              @addConversation="addConversation"
              @refreshConversation="refreshConversationList"
          />
        </keep-alive>
      </el-main>
    </el-container>
    <el-drawer
      class="mobile-sidebar-drawer"
      size="82%"
      :visible.sync="mobileSidebarVisible"
      direction="ltr"
      :with-header="false"
    >
      <Sidebar
        v-if="mobileSidebarVisible"
        ref="mobileSidebar"
        class="mobile-sidebar-panel"
        :curId="curId"
        :isLoading="$refs.banner?.loading"
        @changeCurId="changeCurIdFromMobile"
        @delCurId="delCurIdFromMobile"
      />
    </el-drawer>
    <Login :loginDialogVisible.sync="loginDialogVisible" @updatePage="updatePage"></Login>
    <ResetPass :resetDialogVisible.sync="resetDialogVisible" @updatePage="updatePage"></ResetPass>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import Banner from '../components/Banner.vue'
import Login from '../components/Login.vue'
import { EventBus } from '@/eventBus'
import { refreshUserSessionIfLoggedIn, isSessionLoggedIn } from '@/utils/userSession'
import ResetPass from '@/components/ResetPass.vue'

export default {
  name: 'AppMain',
  components: {
    ResetPass,
    Sidebar,
    Banner,
    Login
  },
  data() {
    return {
      loginDialogVisible: false,
      resetDialogVisible: false,
      mobileSidebarVisible: false,
      curId: null,
    }
  },
  methods: {
    openResetPass() {
      this.resetDialogVisible = true
    },
    openLogin() {
      this.loginDialogVisible = true
    },
    openMobileSidebar() {
      this.mobileSidebarVisible = true
    },
    openLoginIfQuery() {
      if (this.$route.query.openLogin === '1') {
        this.$nextTick(() => {
          this.loginDialogVisible = true
        })
      }
    },
    openLoginIfLoggedOut() {
      if (!isSessionLoggedIn()) {
        this.loginDialogVisible = true
      }
    },
    // 获取用户信息
    // getInfo() {
    //   getInfo().then(res => {
    //     const user = JSON.stringify(res.user || {})
    //
    //     let vip = res.vips[0]
    //     // 替换洞界
    //     vip.title = vip.title?.replace('洞界', '摩投')
    //     vip.packageName = vip.packageName?.replace('洞界', '摩投')
    //     const vips = JSON.stringify(vip || {})
    //
    //     localStorage.setItem('user', user)
    //     localStorage.setItem('vips', vips)
    //     this.refreshPage()
    //   }).catch(err => {
    //     // console.log(err)
    //   })
    //   getStatistic().then(res => {
    //     const { totalInvite, totalPoints, totalSignIn } = res
    //     const statistic = JSON.stringify({
    //       totalInvite,
    //       totalPoints,
    //       totalSignIn
    //     } || {})
    //     localStorage.setItem('statistic', statistic)
    //     this.refreshPage()
    //   }).catch(() => {})
    // },
    updatePage() {
      this.loginDialogVisible = false
      this.resetDialogVisible = false
      // this.getInfo()
      this.$refs.sidebar?.init()
      this.$refs.mobileSidebar?.init()
    },
    // 刷新侧边栏会话列表（不再销毁 Banner，避免丢失对话/SSE 状态）
    refreshPage() {
      this.$refs.sidebar?.init()
      this.$refs.mobileSidebar?.init()
    },
    // 新增会话
    addConversation(conversationId) {
      this.curId = conversationId
      this.$refs.sidebar?.init()
      this.$refs.mobileSidebar?.init()
    },
    // 切换会话
    changeCurId(conversationId) {
      // 回答中不允许切换
      if (this.$refs.banner.loading) return false
      this.curId = conversationId
      return true
    },
    changeCurIdFromMobile(conversationId) {
      const changed = this.changeCurId(conversationId)
      if (changed) {
        this.mobileSidebarVisible = false
      }
    },
    // 删除当前会话
    delCurId() {
      this.curId = null
    },
    delCurIdFromMobile() {
      this.delCurId()
    },
    // 刷新会话列表
    refreshConversationList() {
      this.$refs.sidebar?.init()
      this.$refs.mobileSidebar?.init()
    },
    syncUserSessionFromServer() {
      // 仅更新 localStorage 并通过 EventBus 刷新 UserInfo，不 refreshPage，
      // 否则 v-if 会销毁 Banner，从充值页返回时丢失进行中的对话/SSE 状态
      refreshUserSessionIfLoggedIn()
    },
  },
  created() {
    // 监听全局事件，显示登录弹窗
    EventBus.$on('show-login-modal', () => {
      // localStorage.removeItem('user')
      // localStorage.removeItem('vips')
      // localStorage.removeItem('token')
      this.loginDialogVisible = true
      // 流式生成中不清空会话，避免从充值页返回后对话丢失
      if (this.$refs.banner?.loading || this.$refs.banner?.buildingMessage?.enable) return
      this.curId = null
      this.refreshPage()
    })
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，避免内存泄漏
    EventBus.$off('show-login-modal')
  },
  mounted() {
    this.openLoginIfLoggedOut()
    this.openLoginIfQuery()
    this.syncUserSessionFromServer()
  },
  activated() {
    this.openLoginIfLoggedOut()
    this.syncUserSessionFromServer()
  },
  watch: {
    '$route.query.openLogin'(v) {
      if (v === '1') this.openLoginIfQuery()
    }
  },
}
</script>

<style>
* {
  box-sizing: border-box;
}
/* 仅适用于部分浏览器（如 Chrome） */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent; /* 默认透明 */
  transition: opacity 0.3s;
}

/* 滚动时显示滚动条 */
body:active::-webkit-scrollbar,
body:hover::-webkit-scrollbar {
  background: rgba(0, 0, 0, 0.2); /* 滚动时显示 */
}

#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, sans-serif;
  height: 100vh;
  background-color: #F9F5F1;
}

.app-container {
  display: flex;
  height: 100%;
  min-width: 0;
}

.app-shell {
  min-width: 0;
}

.sidebar-container {}

.main-content {
  flex: 1;
  min-width: 0;
  padding: 20px 0;
  overflow-y: auto;
}

.mobile-sidebar-drawer {
  display: none;
}

@media (max-width: 768px) {
  #app {
    height: 100vh;
    height: 100dvh;
  }

  .app-shell {
    height: 100%;
    overflow: hidden;
  }

  .app-container {
    display: block;
    height: 100%;
  }

  .sidebar-container {
    display: none !important;
  }

  .main-content {
    height: 100%;
    padding: 0;
    overflow: hidden;
  }

  .mobile-sidebar-drawer {
    display: block;
  }

  .mobile-sidebar-drawer .el-drawer {
    background: #F9F5F1;
    overflow: hidden;
  }

  .mobile-sidebar-drawer .el-drawer__body {
    height: 100%;
    overflow: hidden;
  }
}
</style>
<style>
body {
  margin: 0;
  padding: 0;
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.el-textarea__inner {
  border: none;
}

.el-checkbox {
    margin-right: 0;
}
.el-checkbox.is-bordered,
.el-radio.is-bordered {
  padding: 8px 18px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 70px;
  border: 1px solid #F4EFE6;
  line-height: 18px;
}
.no-inner .el-checkbox__inner {
  display: none;
}
.el-tooltip__popper.is-light {
  border: none;
  padding: 0;
}
/* 隐藏 tooltip 的边框 */
.el-tooltip__popper {
  border: none !important; /* 移除 tooltip 容器的边框 */
}

/* 隐藏 tooltip 箭头的边框 */
.el-tooltip__popper .popper__arrow,
.el-tooltip__popper .popper__arrow::after {
  border: none !important; /* 移除箭头的边框 */
}

@media (max-width: 768px) {
  .el-checkbox.is-bordered,
  .el-radio.is-bordered {
    height: 32px;
    padding: 6px 10px;
    border-radius: 18px;
    font-size: 12px;
    line-height: 18px;
  }

  .el-drawer.rtl {
    width: 100% !important;
  }
}
</style>

